// ============================================
// ENGLISH TRANSLATIONS (EN)
// ============================================

import { registerTranslations } from "../LanguageContext";

const en = {
  // Header / Contact
  "contact.email": "Email",
  "contact.phone": "Phone",
  "contact.linkedin": "LinkedIn",
  "contact.github": "GitHub",
  "header.subtitle": "I am currently teaching myself software architecture using AI agent ecosystems and MCP.",

  // Main sections
  "section.about": "About Me",
  "section.experience": "Work Experience",
  "section.education": "Education",
  "section.skills": "Skills",
  "section.certifications": "Certifications",
  "section.languages": "Languages",
  "section.softSkills": "Soft Skills",
  "section.projects": "GitHub Projects",
  "section.interests": "Interests",
  "section.tools": "Tools",
  "section.frontend": "Frontend",
  "section.backend": "Backend",

  // Sobre mí
  "section.about.content": "Software architect with over five years experience and more than two years experience in the sector as a full-stack developer. Throughout my career, I have had the opportunity to develop major projects, both independently and as part of a team, using a range of technologies and making the most of them.",
  
  // Experiencia 1
  "section.experience.first.title": "Dual Vocational Training in IT",
  "section.experience.first.date": "April 2021 - June 2022",
  "section.experience.first.location": "Cambrils, Spain",
  "section.experience.first.skill.one": "CMS maintenance and management (WordPress, PrestaShop)",
  "section.experience.first.skill.two": "Local server management (Windows)",

  // Experiencia 2
  "section.experience.second.title": "IT Technician – Permanent Contract",
  "section.experience.second.date": "June 2022 - Sep 2022",
  "section.experience.second.location": "Cambrils, Spain",
  "section.experience.second.skill.one": "CMS maintenance and management (WordPress, PrestaShop)",
  "section.experience.second.skill.two": "Local server management (Windows)",
  "section.experience.second.skill.three": "Creation and management of social media advertising campaigns",

  // Experiencia 3
  "section.experience.third.title": "Dual Vocational Training in Backend Developer",
  "section.experience.third.date": "Feb 2023 - April 2024",
  "section.experience.third.location": "Remote",
  "section.experience.third.skill.one": "Maintenance and development of web applications using CMS (WordPress, PrestaShop, Drupal)",
  "section.experience.third.skill.two": "Development of modules for Drupal",
  "section.experience.third.skill.three": "Management of self-hosted file-sharing platforms (NextCloud)",

  // Experiencia 4
  "section.experience.forth.title": "Junior FullStack Developer – Permanent Contract",
  "section.experience.forth.date": "Sep 2024 - Dec 2025",
  "section.experience.forth.location": "Remote",
  "section.experience.forth.skill.one": "Stand-alone software testing projects (Selenium, Cypress, PhpUnit)",
  "section.experience.forth.skill.two": "Maintenance and development of web applications using CMS (WordPress, PrestaShop, Drupal)",
  "section.experience.forth.skill.three": "Development of modules for Drupal",
  "section.experience.forth.skill.four": "Development of business management software (ObjectScript + React)",
  "section.experience.forth.skill.five": "Creating a booking system with external connectors (ObjectScript)",
  "section.experience.forth.skill.six": "Maintaining libraries for new versions of Java",
  "section.experience.forth.skill.seven": "Management of self-hosted file-sharing platforms (NextCloud)",

  // Education 1
  "section.education.first.title": "Certificate of Higher Education (HNC) in Cross-Platform Application Development",

  // Education 2
  "section.education.second.title": "Vocational Qualification in Microcomputer Systems and Networks",

  // Education 3
  "section.education.third.title": "Secondary Education",

  // Certificado 1
  "section.certifications.first.title": "AngularJS 1x Certificate",

  // Certificado 2
  "section.certifications.second.title": "React Certificate",

  // Certificado 3
  "section.certifications.third.title": "Introduction to AI Development Certificate",


  // Certifications
  "cert.view": "View credential",

  // Soft Skills
  "softSkill.one": "Creativity",
  "softSkill.two": "Motivation",
  "softSkill.three": "Strong teamwork",
  "softSkill.four": "Independence",
  "softSkill.five": "Good decision-making",
  "softSkill.six": "Perseverance",
  "softSkill.seven": "Responsibility",
  "softSkill.eight": "Discipline",
  "softSkill.nine": "Determination",

  // Interests
  "interests.one": "Web Development",
  "interests.two": "Software Architecture",
  "interests.three": "Continuous Learning",

  // Projects
  "project.public": "Public",
  "project.private": "Private",
  "project.viewRepo": "View repository",
  "project.loading": "Loading repositories...",
  "project.error": "Error loading repositories",
  "project.empty": "No public repositories found",
  "project.viewAll": "View all",

  // CV Download
  "cv.download": "Download CV (PDF)",

  // States
  "status.loading": "Loading...",
  "status.error": "Error",
  "status.empty": "No data",

  // Footer
  "footer.madeWith": "Made with React + TypeScript",

  // Language
  "language.es": "Spanish",
  "language.en": "English",
  "language.ca": "Catalan",

  // Language Selector
  "language.select": "Select language",
  "language.selector.es": "Español",
  "language.selector.en": "English",

  // Language levels
  "language.level.native": "Native",
  "language.level.b2": "Very High (Cambridge B2 Certificate)",
  "language.level.veryHigh": "Very High",

  // Errors
  "error.generic": "Something went wrong",
  "error.retry": "Retry",
};

registerTranslations("en", en);

export default en;